import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const RelayWrongAnswerPopupHider = ( props ) => {

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };

  useEffect( () => {
    const timer = setTimeout( hideRelayWrongAnswerPopup, 2000 );
    return () => {
      clearTimeout( timer );
    };
  }, [] );

  const hideRelayWrongAnswerPopup = () => {
    setAnsweringQuestions( {
      isShowRelayWrongAnswerPopup : false,
      isShowConceptCheckPlayer : true
    } );
  };

  return props.children || null;

};

export default RelayWrongAnswerPopupHider;
